import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useDeleteSingleSeriesMutation = createMutationHook(
  MembershipsCreatorV2ApiClient.deleteSingleSeries,
  {
    mutationKey: ['deleteSingleSeries'],
  },
)
